import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

// const CancelConfirmDialog = ({ open, onClose, onConfirm }) => {
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
//         <Typography variant="h6">Confirm Cancel</Typography>
//         <IconButton onClick={onClose}>
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{ textAlign: "center", py: 3 }}>
//         Are you sure you want to cancel this action?
//       </DialogContent>

//       <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
//         <button className="btn BlueBtn" onClick={onConfirm}>
//           Yes
//         </button>
//         <button className="btn-negative" onClick={onClose}>
//           No
//         </button>
//       </DialogActions>
//     </Dialog>
//   );
// };
const CancelConfirmDialog = ({ open, onClose, onConfirm, title, message }) => (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">{title || "Confirm Cancel"}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
  
      <DialogContent sx={{ textAlign: "center", py: 3 }}>
        {message || "Are you sure you want to cancel?"}
      </DialogContent>
  
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <button className="btn" onClick={onConfirm}>
          Yes
        </button>
        <button className="btn-negative" onClick={onClose}>
          No
        </button>
      </DialogActions>
    </Dialog>
  );
  

export default CancelConfirmDialog;
